import React from 'react';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import styled from 'styled-components';

export default function HeaderLabelIcons({ orderBy, headCell, order, className }) {
  return (
    <LabelIcons className={className}>
      <IconContainer>
        {(orderBy !== headCell.id || (orderBy === headCell.id && order === 'asc')) && (
          <StyledArrowDropUpIcon active={orderBy === headCell.id} />
        )}
      </IconContainer>
      <IconContainer>
        {(orderBy !== headCell.id || (orderBy === headCell.id && order === 'desc')) && (
          <StyledArrowDropDownIcon active={orderBy === headCell.id} />
        )}
      </IconContainer>
    </LabelIcons>
  );
}

const LabelIcons = styled.span`
  margin-top: -16px;
`;
const IconContainer = styled.div`
  width: 24px;
  height: 7px;
`;
const StyledArrowDropDownIcon = styled(ArrowDropDownIcon)`
  color: ${(props) => (props.active ? '#535354' : '#cacaca')};
`;
const StyledArrowDropUpIcon = styled(ArrowDropUpIcon)`
  color: ${(props) => (props.active ? '#535354' : '#cacaca')};
`;
